import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransformDurationToTextPipe } from './transform-duration-to-text.pipe';

/**
 * The TransformDurationToText module
 *
 * import { TransformDurationToTextModule } from 'styleguide/src/shared/pipe/transform-duration-to-text.module';
 */
@NgModule({
    declarations: [
        TransformDurationToTextPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TransformDurationToTextPipe
    ]
})

export class TransformDurationToTextModule {
}
